module.exports = __webpack_public_path__ + "static/media/default-image.28e2db6d.svg";